const fromStoreOfferByIdQueryToStore = (data) => {
  if (!data) {
    return null;
  }
  try {
    return data.offers.map((offer) => {
      const { title, description, url, imageUrl } = offer;
      return {
        title,
        description: description ?? void 0,
        url: url ?? void 0,
        imageUrl: imageUrl ?? void 0
      };
    });
  } catch (e) {
    console.error("Store offer data adapter failed to parse input data correctly.", e, data);
    return null;
  }
};
export {
  fromStoreOfferByIdQueryToStore
};
//# sourceMappingURL=fromStoreOfferByIdQueryToStore.js.map
